var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_292_1694)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.86 11.9998C18.3504 11.9998 19.5492 10.8478 19.5492 9.42838C19.5492 8.00895 18.3504 6.85695 16.86 6.85695C15.3696 6.85695 14.16 8.00895 14.16 9.42838C14.16 10.8478 15.3696 11.9998 16.86 11.9998ZM8.76001 10.9712C10.5528 10.9712 11.9892 9.59295 11.9892 7.88552C11.9892 6.17809 10.5528 4.7998 8.76001 4.7998C6.96721 4.7998 5.52001 6.17809 5.52001 7.88552C5.52001 9.59295 6.96721 10.9712 8.76001 10.9712ZM16.86 14.0569C14.8836 14.0569 10.92 15.0032 10.92 16.8855V19.1998H22.8V16.8855C22.8 15.0032 18.8364 14.0569 16.86 14.0569ZM8.76001 13.0284C6.24361 13.0284 1.20001 14.2318 1.20001 16.6284V19.1998H8.76001V16.8855C8.76001 16.0112 9.11641 14.4787 11.3196 13.3164C10.38 13.1312 9.47281 13.0284 8.76001 13.0284Z",
    fill: "url(#paint0_linear_292_1694)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.86 11.9998C18.3504 11.9998 19.5492 10.8478 19.5492 9.42838C19.5492 8.00895 18.3504 6.85695 16.86 6.85695C15.3696 6.85695 14.16 8.00895 14.16 9.42838C14.16 10.8478 15.3696 11.9998 16.86 11.9998ZM8.76001 10.9712C10.5528 10.9712 11.9892 9.59295 11.9892 7.88552C11.9892 6.17809 10.5528 4.7998 8.76001 4.7998C6.96721 4.7998 5.52001 6.17809 5.52001 7.88552C5.52001 9.59295 6.96721 10.9712 8.76001 10.9712ZM16.86 14.0569C14.8836 14.0569 10.92 15.0032 10.92 16.8855V19.1998H22.8V16.8855C22.8 15.0032 18.8364 14.0569 16.86 14.0569ZM8.76001 13.0284C6.24361 13.0284 1.20001 14.2318 1.20001 16.6284V19.1998H8.76001V16.8855C8.76001 16.0112 9.11641 14.4787 11.3196 13.3164C10.38 13.1312 9.47281 13.0284 8.76001 13.0284Z",
    fill: "url(#paint1_linear_292_1694)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.86 11.9998C18.3504 11.9998 19.5492 10.8478 19.5492 9.42838C19.5492 8.00895 18.3504 6.85695 16.86 6.85695C15.3696 6.85695 14.16 8.00895 14.16 9.42838C14.16 10.8478 15.3696 11.9998 16.86 11.9998ZM8.76001 10.9712C10.5528 10.9712 11.9892 9.59295 11.9892 7.88552C11.9892 6.17809 10.5528 4.7998 8.76001 4.7998C6.96721 4.7998 5.52001 6.17809 5.52001 7.88552C5.52001 9.59295 6.96721 10.9712 8.76001 10.9712ZM16.86 14.0569C14.8836 14.0569 10.92 15.0032 10.92 16.8855V19.1998H22.8V16.8855C22.8 15.0032 18.8364 14.0569 16.86 14.0569ZM8.76001 13.0284C6.24361 13.0284 1.20001 14.2318 1.20001 16.6284V19.1998H8.76001V16.8855C8.76001 16.0112 9.11641 14.4787 11.3196 13.3164C10.38 13.1312 9.47281 13.0284 8.76001 13.0284Z",
    fill: "current",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "color"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.86 11.9998C18.3504 11.9998 19.5492 10.8478 19.5492 9.42838C19.5492 8.00895 18.3504 6.85695 16.86 6.85695C15.3696 6.85695 14.16 8.00895 14.16 9.42838C14.16 10.8478 15.3696 11.9998 16.86 11.9998ZM8.76001 10.9712C10.5528 10.9712 11.9892 9.59295 11.9892 7.88552C11.9892 6.17809 10.5528 4.7998 8.76001 4.7998C6.96721 4.7998 5.52001 6.17809 5.52001 7.88552C5.52001 9.59295 6.96721 10.9712 8.76001 10.9712ZM16.86 14.0569C14.8836 14.0569 10.92 15.0032 10.92 16.8855V19.1998H22.8V16.8855C22.8 15.0032 18.8364 14.0569 16.86 14.0569ZM8.76001 13.0284C6.24361 13.0284 1.20001 14.2318 1.20001 16.6284V19.1998H8.76001V16.8855C8.76001 16.0112 9.11641 14.4787 11.3196 13.3164C10.38 13.1312 9.47281 13.0284 8.76001 13.0284Z",
    fill: "current",
    fillOpacity: 0.42,
    style: {
      mixBlendMode: "multiply"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_292_1694",
    x1: 1.20001,
    y1: 4.7998,
    x2: 1.20001,
    y2: 19.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88A2B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#677B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_292_1694",
    x1: 11.3556,
    y1: 4.7998,
    x2: 11.3556,
    y2: 5.65897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D1DE",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D1DE",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_292_1694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.05342b266e3ecdc3cc7d3dc9039602d2.svg";
export { ForwardRef as ReactComponent };